import O1HD from "../../../engines/gameEngine";
import { stallData } from "./DefineInterface";
import NormalGameManager from "./NormalGameManager";

export default class stallManager{

    manager:NormalGameManager = null;

    private _stall_Save_Key:string = "stall-manager-save-key";

    private _data:stallData = {
        unlockItems: [0,1,2]
    };

    private _initData:stallData = {
        unlockItems: [0,1,2]
    }

    constructor(manager:NormalGameManager){
        this.manager = manager;
        this.loadManager();
    }

    loadManager(){
        let dataStr = O1HD.getServices().localStorageSrv.getStorage(this._stall_Save_Key) || JSON.stringify(this._initData);
        if(dataStr == ""){
            dataStr = JSON.stringify(this._initData);
        }
        this._data = JSON.parse(dataStr);
        this.writeData();
    }
    
    setData(data:stallData,isPlus:boolean = false){
        for (let key in data) {
            let k = data[key];
            if (k != null) {
                if (k instanceof Array) {
                    if (isPlus) {
                        this._data[key] = this._data[key].concat(k);
                    } else {
                        this._data[key] = [].concat(k);
                    }
                } else {
                    if (isPlus) {
                        this._data[key] += k;
                    } else {
                        this._data[key] = k;
                    }
                }
            }
        }
        this.writeData();
    }

    getData(){
        return this._data;
    }

    writeData(){
        O1HD.getServices().localStorageSrv.setStorage(this._stall_Save_Key,JSON.stringify(this._data));
    }

    resetManager(){
        this.setData(this._initData);
    }

}
